/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var activeDiscountCode;
  var isPercentageDiscount;
  var discountValue;
  
  // Prices
  var currentPriceInCents= 0;
  var compareAtPriceInCents= 0;
  var discountAmountInCents = 0;
  var priceAfterDiscountInCents= 0;

  //You Safe Message
  var discountfromCompareAtPriceAbs;
  var discountfromCompareAtPriceRel;
  
  var productIsOnSale;

  // Variant information
  var currentVariantId; 
  var currentVariantObject;
  
 
  /*Enhancing the theme hook for changing parts of the PDP if the variant is changed*/
  document.addEventListener('theme:variant:change', handleVarianteChange);
  document.addEventListener('theme:cart:update:custom', handleCartChange);
  document.addEventListener('sealsubs:price_update', updatePriceSellingPlanChange);
  

  function updatePriceSellingPlanChange(e){
    console.log(JSON.stringify(e.detail));
    
    // get prices
    currentPriceInCents = e.detail.price;
    compareAtPriceInCents = e.detail.compareAtPrice;
    productIsOnSale = compareAtPriceInCents != currentPriceInCents; 
    
    // calculate final price
    priceAfterDiscountInCents = currentPriceInCents-discountAmountInCents;

    // calculate you safe messages
    discountfromCompareAtPriceAbs = compareAtPriceInCents-priceAfterDiscountInCents;
    discountfromCompareAtPriceRel = discountfromCompareAtPriceAbs/compareAtPriceInCents * 100; 

    // Update you save msg
    updateProductPrice(e);

    if(e.srcElement.querySelector("[data-"+currentVariantId+"-option-msg]")){
       e.srcElement.querySelector("[data-"+currentVariantId+"-option-msg]").innerHTML =formatMoney(currentPriceInCents);
       e.srcElement.querySelector("[data-"+currentVariantId+"-option-save-msg]").innerHTML ="(spare "+formatMoney(discountfromCompareAtPriceAbs)+")";
    }    
  }
  
  function handleVarianteChange(e){  
    // get Variant and product object
    currentVariantId = e.detail.variant.id;
    currentVariantObject = {};

    try {
          currentVariantObject = customProductVariantInfo[""+currentVariantId]
    } catch (error) {
       console.log("error:" +JSON.stringify(error)); 
    }
    
    // Updates the text under variant
    updateTexts(e);
    
    // Update prices on the pdp
    prepareDiscountInformation ();
    calculcatePrices();
    updateYouSaveMsg(e);
    updateProductPrice(e);

    // displays discount code on pdp and cart
    displayDiscountCode();
    
    // update the cart drawer
    updateCart(e);

    //check for skin quiz
    skinquizUpdates();
  }

  function handleCartChange(e){
   console.log("Update Cart") 
   updateCart(e);
  }

  function makeVisible(customId){
    console.log("custom_item_"+customId);
    var el = document.getElementById("custom_item_"+customId);
    if(el){
      el.style.display = "block"; 
    }
  }

  function skinquizUpdates(){
    // check if this a skintest result page info=span_,pick_,glan_,selb_,acht_,opt_,alt_,spa_&umw=&por=&pic=&span=
    if (window.location.href.indexOf("dein-hauttyp-passt") > -1) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      try {
      if(!(params.info)){
        makeVisible("span_1");
        makeVisible("pick_1");
        makeVisible("por_1");
        makeVisible("alt_1");
        makeVisible("spa_1");
      }
        
      if(params.info){
        var str_array = params.info.split(',');
        for(var i = 0; i < str_array.length; i++) {
           if(str_array[i].indexOf("_1") > -1){
            makeVisible(str_array[i]);(str_array[i]);
           }
        }
      }

      if(params.span > 0){
        makeVisible("span_1");
      }
      if(params.umw > 0){
        makeVisible("spa_1");
      }
      if(params.por > 0){
        makeVisible("por_1");
      }
      if(params.pic > 0){
        makeVisible("pick_1");
      }

      makeVisible("spa_1");  
        
        
      } catch (error) {
        console.log(error);
      }
    }

    
  }

  function prepareDiscountInformation(){
    
    activeDiscountCode = getDiscountCookieValue();
    if(activeDiscountCode){  
      isPercentageDiscount = checkIfDiscountIsPercentage(activeDiscountCode);
      discountValue = getDiscountValueFromString(activeDiscountCode); 
      console.log("Code:" + activeDiscountCode +" is %-Discount:"+isPercentageDiscount+" Value:"+discountValue );
    }
  }

  function updateTexts(e){    
   if( e.srcElement.querySelector(".custom_CSS_option_subtext_text")){
     if(currentVariantObject){
      e.srcElement.querySelector(".custom_CSS_option_subtext_title").innerHTML = "Dein Auswahl: "+ currentVariantObject.title;
      e.srcElement.querySelector(".custom_CSS_option_subtext_text").innerHTML = currentVariantObject.additionalUsageInformation;
     }
   }  
    
   if(e.srcElement.querySelector(".custom_CSS_product_delivery_msg")){
      if(currentVariantObject){
        e.srcElement.querySelector(".custom_CSS_product_delivery_msg").innerHTML = currentVariantObject.inventory_msg;
        e.srcElement.querySelector(".custom_CSS_product_delivery_msg").style.color = currentVariantObject.inventory_msg_color;
      }

   } 
  };
  
  function calculcatePrices(){
    var product_data_model = custom_js_product_variant;

    // get prices
    currentPriceInCents = custom_js_product_variant.price?custom_js_product_variant.price:0;
    compareAtPriceInCents = custom_js_product_variant.compare_at_price?custom_js_product_variant.compare_at_price:custom_js_product_variant.price;
    productIsOnSale = compareAtPriceInCents != currentPriceInCents;    
    
    // calculate final price
    priceAfterDiscountInCents = currentPriceInCents-discountAmountInCents;

    // calculate you safe messages
    discountfromCompareAtPriceAbs = compareAtPriceInCents-priceAfterDiscountInCents;
    discountfromCompareAtPriceRel = discountfromCompareAtPriceAbs/compareAtPriceInCents * 100;   
    
    console.log("Final Price: " + formatMoney(priceAfterDiscountInCents) + " Price before discount " +
                formatMoney(currentPriceInCents)+ " Price before discount " + formatMoney(compareAtPriceInCents)+ " You save: "+formatMoney(discountfromCompareAtPriceAbs)+" ("+discountfromCompareAtPriceRel+"%)"+" Sale: "+productIsOnSale);
  }

  function formatMoney(money){
      return themeVendor.themeCurrency.formatMoney(money,theme.moneyFormat);
  }
  
  function getCookie1(name) {
        var value = "; " + document.cookie;
        var parts = value.split('; '+name+'=');
        if (parts.length == 2) return parts.pop().split(";").shift();
  };

  function displayDiscountCode(){
      if(activeDiscountCode){
        document.getElementById("pdp_discount_code").innerHTML="" + activeDiscountCode;
        document.getElementById("pdp_discount_msg").style.display = "block";       
        document.getElementById("pdp_discount_code_cart2").innerHTML="" + activeDiscountCode + "";
        document.getElementById("cart_discount_code_container").style.display ="flex";
         document.getElementById("cart_discount_code_container1").style.display ="none";
        document.getElementById("cart_general_subtotal_note").style.display = "none";        
      }else{
        console.log("No discount Code");
      }
    }
  
  function getDiscountCookieValue(){
    var codeCookieValue = getCookie1('discount_code');
    if(codeCookieValue == 'DankeDankeDanke'){
      return 'DankeDankeDanke20'
    }
    return codeCookieValue;
  }

  function checkIfDiscountIsPercentage(s){
    return !(s.indexOf("Abo") !== -1);
  }

  function getDiscountValueFromString(s){
     var regex = /[0-9]{2}/;
     var matchString = s.match(regex);
     if(matchString){
        return matchString[0];
     }
     
    return null;    
  }

  function updateCart(e){
      var total_price = window.custom_JS_total_price;
       if (typeof(window.custom_JS_total_price) != "undefined"){
        if(window.custom_JS_total_price === 0){
          // all items are removed from cart so we need to clean up

          // remove total after discount;
          document.getElementById("cart_total_after_discount").style.display ="none";

          // remove delivery costs
          document.getElementById("cart_shipping_costs_container").style.display ="none";

          // remove active discount
          document.getElementById("cart_discount_code_container").style.display ="none";
          
        }else {
        // update cart sub total
        document.getElementById("data-cart-total-before-discount").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(total_price,e.detail.formatMoney);
        
          // check for discount and update discount
          //total_price -= checkforDiscountAndUpdateDiscount(e,total_price);
          // check country picker and shipping costs
          if(total_price>=4500){
            console.log("free shipping");
            document.getElementById("cart_shipping_costs_label").innerHTML ="Versand nach 🇩🇪 & 🇦🇹:";
            // document.getElementById("cart_shipping_costs").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(0,e.detail.formatMoney)
              document.getElementById("cart_shipping_costs").innerHTML = "kostenlos";
          }else{
            console.log("no free shipping");
            document.getElementById("cart_shipping_costs_label").innerHTML ="Versand (kostenlos ab 45€) nach 🇩🇪 & 🇦🇹:"
            document.getElementById("cart_shipping_costs").innerHTML = "+ " + e.detail.themeCurrencyFormatter.formatMoney("390",e.detail.formatMoney)
            total_price = total_price + 390;
          }
        // show shipping costs
        document.getElementById("cart_shipping_costs_container").style.display ="flex";
          
        // update total price
        document.getElementById("data-cart-total").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(total_price,e.detail.formatMoney);

        if (typeof(activeDiscountCode) === "undefined"){
          // remove total after discount;
          document.getElementById("cart_total_after_discount").style.display ="none";
         }else{
          //display price after discount
         // document.getElementById("cart_total_after_discount").style.display ="flex";
         // if (isDiscountforSupscription(activeDiscountCode)) {
         //   document.getElementById("data-cart-total-after-discount").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(window.custom_JS_total_price - (discountValue*100),e.detail.formatMoney);
         // } else {
         //   document.getElementById("data-cart-total-after-discount").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(window.custom_JS_total_price * ((100-discountValue)/100),e.detail.formatMoney);
         // }
         }
        
        //update Cart Msg
          cart.updateProgress(window.custom_JS_total_price);
          cart.freeShippingMessageHandle(window.custom_JS_total_price);
        }
     }else{
        var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => { 
          var total_price2 = data.total_price;
          document.getElementById("data-cart-total-before-discount").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(total_price2,e.detail.formatMoney);
          
          // check for discount and update discount
          //total_price2 -= checkforDiscountAndUpdateDiscount(e,total_price2);
          // check country picker and shipping costs
          if(total_price2>=4500){
            console.log("free shipping");
            document.getElementById("cart_shipping_costs_label").innerHTML ="Versand (DHL Go Green) nach 🇩🇪&🇦🇹:"
           // document.getElementById("cart_shipping_costs").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(0,e.detail.formatMoney)
            document.getElementById("cart_shipping_costs").innerHTML = "kostenlos";
          }else{
            console.log("no free shipping");
            document.getElementById("cart_shipping_costs_label").innerHTML ="Versand (kostenlos ab 45€) nach 🇩🇪&🇦🇹:"
            document.getElementById("cart_shipping_costs").innerHTML = "+ " + e.detail.themeCurrencyFormatter.formatMoney("390",e.detail.formatMoney)
            total_price2 = total_price2 + 390;
          }
          // show shipping costs
          document.getElementById("cart_shipping_costs_container").style.display ="flex";
          
          // update total price
           document.getElementById("data-cart-total").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(total_price2,e.detail.formatMoney);

        if (typeof(activeDiscountCode) === "undefined"){
          // remove total after discount;
          document.getElementById("cart_total_after_discount").style.display ="none";
         }else{
          //display price after discount
         // document.getElementById("cart_total_after_discount").style.display ="flex";
//
         // if (isDiscountforSupscription(activeDiscountCode)) {
         //   document.getElementById("data-cart-total-after-discount").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(data.items_subtotal_price - (discountValue*100),e.detail.formatMoney);
         // } else {
         //   document.getElementById("data-cart-total-after-discount").innerHTML = e.detail.themeCurrencyFormatter.formatMoney(data.items_subtotal_price * ((100-discountValue)/100),e.detail.formatMoney);
         // }
          
          
         }

          //update Cart Msg
          cart.updateProgress1(data.items_subtotal_price);
          cart.freeShippingMessageHandle(data.items_subtotal_price);
          
          });
     }
  }

  function checkforDiscountAndUpdateDiscount(e,total_price){
      var codeCookieValue = getDiscountCookieValue();
    
      if(codeCookieValue){
        var price = total_price;
        var discountValue = getDiscountValueFromString(codeCookieValue);
        var discountPrice;
        if(isDiscountforSupscription(codeCookieValue)){
          discountPrice = discountValue * 100
        }
        else{
          discountPrice = price * (discountValue)/100;
        }
        var final_discount_price = e.detail.themeCurrencyFormatter.formatMoney(discountPrice, e.detail.formatMoney)
        
        document.getElementById("cart_discount_code_value").innerHTML = "-"+final_discount_price;
        document.getElementById("cart_discount_code_container").style.display ="flex";
        
        var priceAfterAdditionalDiscount = price * (100-discountValue)/100;
        var final_price = e.detail.themeCurrencyFormatter.formatMoney(priceAfterAdditionalDiscount, e.detail.formatMoney)
        
        return discountPrice;
      }

    return 0;
  }

  function isDiscountforSupscription(codeCookieValue){
      return (codeCookieValue.indexOf("Abo") !== -1)
  }
  
  
  function updateYouSaveMsg(e){
   if( e.srcElement.querySelector(".custom_CSS_product_price_off_msg_inner")){
     var realPrice;
     
     if(e.detail.formState.plan){
     	realPrice = e.detail.formState.plan.allocation.price;
     }
     else{
     	realPrice = e.detail.variant.price;
     }
          
     var tmpString = Math.round((e.detail.variant.compare_at_price - realPrice)/100);
     e.srcElement.querySelector(".custom_CSS_product_price_off_msg_inner").innerHTML = "spare "+tmpString + theme.moneyFormat.split("}}")[1];
   }    
  };
  
  function updateProductPrice(e){
    
     // Update strike price
    e.srcElement.querySelector("[data-compare-price]").innerHTML = formatMoney(compareAtPriceInCents);
    // Update current price
    e.srcElement.querySelector("[data-product-price]").innerHTML = formatMoney(priceAfterDiscountInCents);
    // Update you save msg
    e.srcElement.querySelector("[data-you-save-msg]").innerHTML =" spare "+formatMoney(discountfromCompareAtPriceAbs);
    e.srcElement.querySelector("[data-price-off-amount]").innerHTML = Math.floor(discountfromCompareAtPriceRel) +"%";

    if (compareAtPriceInCents != priceAfterDiscountInCents) {
     //when product is not on sale, we need to add the html  
     e.srcElement.querySelector("[data-compare-price]").classList.remove("hide");  
    }else{
     e.srcElement.querySelector("[data-compare-price]").classList.add("hide");  
    }

    if (discountfromCompareAtPriceAbs>0) {
     //when product is not on sale, we need to add the html  
     e.srcElement.querySelector("[data-price-off]").classList.remove("hide");  
    }else{
     e.srcElement.querySelector("[data-price-off]").classList.add("hide");   
    }
  };

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
